import Option from "config/option";

/**
 * 뷰어 미리보기 공통 고정 설정
 * 미리보기에서는 불필요한 기능을 비활성화
 */
export const PREVIEW_FIXED_CONFIG = Object.freeze({
    UI_TEXT_LAYER_ENABLE: false,
    UI_ANNOTATION_LAYER_ENABLE: false,
    UI_BOTTOM_CONTROLS_AUTO_HIDE: false,
    UI_FUNC_PRINT_CLIENT_ENABLE: false,

    UI_FUNC_RIGHT_CLICK_ENABLE: false,
    UI_FUNC_SHORT_CUT_ENABLE: false,
    UI_OPEN_SCREEN_MODE: "BASIC",
    UI_OPEN_PANEL: false,
    UI_OPEN_SCALE_MODE: "WIDTH",

    UI_FUNC_ZOOM_ENABLE: false,
    UI_FUNC_PRINT_ENABLE: false,
    UI_FUNC_DOWNLOAD_ENABLE: false,
    UI_FUNC_FULL_SCREEN_ENABLE: false,
    UI_FUNC_ROTATE_ENABLE: false,
    UI_FUNC_SEARCH_ENABLE: false,
    UI_FUNC_FIND_ENABLE: false,
    UI_FUNC_BOOK_MODE_ENABLE: false,
    UI_PANEL_ENABLE: false,
    UI_FUNC_HIGH_CONTRAST_ENABLE: false,
});

/**
 * 뷰어 미리보기 공통 문서(sample.pdf) 세트
 * - 모든 미리보기 임베드에서 동일하게 사용
 */
export const PREVIEW_DOCUMENTS = Object.freeze({
    sample: {
        id: "sample",
        url: Option.INTO_FILE.SAMPLE_PDF,
        title: "sample",
        status: "COMPLETE",
        watermarks: [],
    },
});

/**
 * 뷰어 미리보기 공통 IntoPdfViewer base props
 * - 모달별로 다른 config는 개별 지정
 */
export const PREVIEW_VIEWER_PROPS = Object.freeze({
    embedded: true,
    device: "mobile",
    resources: Option.RESOURCE_PATH,
    timestampImage: null,
    viewType: "DEFAULT",
    documentStructure: null,
    documents: PREVIEW_DOCUMENTS,
    onPrint: null,
    onDownload: null,
});

/**
 * 미리보기 뷰어정보(SYSTEM) 예시 데이터 생성
 *
 * @param {Object}   [opts]
 * @param {string}   [opts.name]       뷰어 이름 (없으면 예시명)
 * @param {Array}    [opts.documents]  [{DOCUMENT_NAME, DOCUMENT_EXTENSION}] (없으면 sample.pdf)
 * @param {string}   [opts.expireDate] 만료일 문자열 (없으면 현재 날짜)
 */
export const buildPreviewSystem = ({name, documents, expireDate} = {}) => ({
    VIEWER_NAME: name || "뷰어 미리보기",
    // 생성일은 미리보기 시점에 없음, 만료일은 입력값이 있을 때만
    VIEWER_CREATED_DATE: "",
    VIEWER_EXPIRED_DATE: expireDate || "",
    VIEWER_DOCUMENT_LIST: (documents && documents.length > 0)
        ? documents
        : [{DOCUMENT_NAME: "sample.pdf", DOCUMENT_EXTENSION: "pdf"}],
});
